import { useState } from 'react'

/**
 * Xem trước nội dung rich-text **đúng như web sẽ hiện**: cùng lớp chữ `prose-nhanho`, cùng
 * cách cắt cao + gradient + nút "Xem thêm" của `apps/web/components/category/LongContent.tsx`.
 * Mục đích chính là để người viết thấy **chỗ nội dung bị cắt** nằm ở đâu.
 *
 * ⚠️ Render HTML **chưa qua sanitize** — server chỉ lọc lúc GHI. Chấp nhận được vì nguồn là
 * trình soạn thảo của chính người dùng đang đăng nhập, trong trang quản trị. **Đừng** đem
 * component này đi render HTML từ nguồn khác (`CLAUDE.md` §3).
 */
export function RichTextPreview({ html, title }: { html: string; title?: string }) {
  const [open, setOpen] = useState(false)

  if (!html.trim()) {
    return <p className="rounded-card border border-dashed border-border-strong px-4 py-8 text-center text-sm text-ink-muted">Chưa có nội dung — khối này sẽ không hiện trên web.</p>
  }

  return (
    <div className="rounded-card border border-border bg-white p-5">
      {title && <h2 className="mb-3 font-heading text-h3 text-ink">{title}</h2>}
      <div className="relative">
        <div
          className={`prose-nhanho overflow-hidden text-sm text-ink-soft ${open ? '' : 'max-h-[300px]'}`}
          dangerouslySetInnerHTML={{ __html: html }}
        />
        {!open && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-white to-transparent" />}
      </div>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="mt-3 text-sm font-medium text-primary-700 hover:underline"
      >
        {open ? 'Thu gọn' : 'Xem thêm'}
      </button>
      <p className="mt-2 text-xs text-ink-faint">
        Xem trước — trên web khối này cao 400px (máy tính) / 200px (điện thoại) trước khi bấm Xem thêm.
      </p>
    </div>
  )
}
